export const changeToType = change => (typeof change === 'object' ? 'updated' : change)
